import immJs from 'lodash';

function SettingsReducer(state = {}, action) {
  const newState = immJs.cloneDeep(state);
  let provider = newState.externalProvider;
  if (provider === undefined) {
    provider = {};
  }
  switch (action.type) {
    case 'SET_SETTINGS':
    case 'GET_SETTINGS':
      return {
        ...state,
        settings: action.payload,
        settingsLoadFailed: false,
      };
    case 'GET_SETTINGS_FAILED':
      return { ...state, settingsLoadFailed: true };
    case 'GET_URLS':
      for (let index = 0; index < action.payload.Providers.length; index += 1) {
        provider[action.payload.Providers[index].ProviderName] = action.payload.Providers[index];
      }
      newState.externalProvider = provider;
      return {
        ...state,
        ...newState,
      };
    case 'REVOKE_ACCESS':
      for (let index = 0; index < action.payload.Providers.length; index += 1) {
        provider[action.payload.Providers[index].ProviderName].Registered = false;
      }
      newState.externalProvider = provider;
      return {
        ...state,
        ...newState,
      };
    default:
      return { ...state };
  }
}

function getSettings(state) {
  return state.SettingsReducer.settings;
}

function getUrls(state) {
  return state.SettingsReducer.externalProvider;
}

function getSettingsLoadFailed(state) {
  return state.SettingsReducer.settingsLoadFailed;
}

export { SettingsReducer, getSettings, getUrls, getSettingsLoadFailed };
